import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItemButton,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  Check as AllEcrfCompleted,
  PriorityHigh as EcrfHasIssue,
  Remove as NotEcrfTouched,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { ECRF_STATUSES, USER_ROLES } from "../../utils/constants";

dayjs.extend(utc);

const FilterPatientPopUp = ({ setFilterPatientPopUp, filterPatient, trialId, trialStructure }) => {
  const navigate = useNavigate();

  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const isCro = user_data.role === USER_ROLES.CRO;

  const routeTo = (id) => {
    const page = trialStructure === "visit_based" ? "ecrf" : "visit_status";
    let link = "/patient/" + id + "/" + page + "?trial=" + trialId;

    const newTab = window.open(link, "_blank");
    if (newTab) {
      newTab.focus();
    } else {
      navigate(link);
    }
  };

  const renderEcrfStatusIcon = (ecrf_status) => {
    let ecrfStatusIcon = <></>;

    if (ecrf_status === ECRF_STATUSES.COMPLETED) {
      ecrfStatusIcon = <AllEcrfCompleted sx={{ color: "green", ml: 2, fontSize: 16 }} />;
    } else if (ecrf_status === ECRF_STATUSES.NEUTRAL) {
      ecrfStatusIcon = <NotEcrfTouched sx={{ color: "grey", ml: 2, fontSize: 16 }} />;
    } else {
      ecrfStatusIcon = <EcrfHasIssue sx={{ color: "red", ml: 2, fontSize: 16 }} />;
    }

    return ecrfStatusIcon;
  };

  return (
    <Dialog
      open
      onClose={() => setFilterPatientPopUp(false)}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle>
        <IconButton
          onClick={() => setFilterPatientPopUp(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" fontWeight="bold" textAlign="center" gutterBottom>
          Subjects
        </Typography>
        <List disablePadding>
          {filterPatient.map((item) => (
            <ListItemButton
              key={item.id}
              onClick={isCro ? undefined : () => routeTo(item.id)}
              disabled={isCro}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", width: 120 }}>
                  <Typography variant="body2" fontWeight={700}>
                    {item?.participant_id || "-"}
                  </Typography>
                  {renderEcrfStatusIcon(item?.overall_ecrf_status)}
                </Box>
                <Box sx={{ display: "flex", flex: 1, gap: 2 }}>
                  <Typography variant="body2" color="text.secondary" fontSize={12} sx={{ flex: 1 }}>
                    Last App Activity:{" "}
                    {item?.last_inapp_visit_date
                      ? dayjs.utc(item.last_inapp_visit_date).local().format("MMM D, YYYY h:mm A")
                      : "no activity"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontSize={12} sx={{ flex: 1 }}>
                    Last InClinic Activity:{" "}
                    {item?.last_inclinic_activity
                      ? dayjs.utc(item.last_inclinic_activity).local().format("MMM D, YYYY h:mm A")
                      : "no activity"}
                  </Typography>
                </Box>
              </Box>
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default FilterPatientPopUp;
